import Vue from 'vue';
import moment from 'moment';
import {
	dateRangeTypes,
} from '@/constants/jobFilter';
import feathersClient from '../../feathers-client';

const defaultFeedbackPagination = {
	total: 100,
	$skip: 0,
	$limit: 6,
};

const defaultFeedbacksFilter = {
	careLocationId: [],
	$dateFrom: moment().format('YYYY-MM-DD'),
	$dateTo: moment().format('YYYY-MM-DD'),
	$skip: defaultFeedbackPagination.$skip,
	$limit: defaultFeedbackPagination.$limit,
};

export default {
	namespaced: true,
	state: {
		staffFeedbacks: [],
		staffFeedbackAggregations: {},
		staffFeedbacksGroupedByDate: {},
		rangeType: dateRangeTypes.selectedDay,
		feedbacksFilter: defaultFeedbacksFilter,
		feedbacksPagination: defaultFeedbackPagination,
	},
	getters: {
		feedbacksPage: (state) => {
			const { $limit, $skip } = state.feedbacksPagination;
			return $skip / $limit + 1;
		},
		staffFeedbacks: (state) => state.staffFeedbacks,
		staffFeedbacksGroupedByDate: (state) => state.staffFeedbacksGroupedByDate,
		staffFeedbackAggregations: (state) => state.staffFeedbackAggregations,
	},
	mutations: {
		SET_RANGE_TYPE: (state, rangeType) => {
			state.rangeType = rangeType;
		},
		SET_STAFF_FEEDBACKS: (state, staffFeedbacks) => {
			state.staffFeedbacks = [...staffFeedbacks];
		},
		SET_STAFF_FEEDBACK_AGGREGATIONS: (state, staffFeedbackAggregations) => {
			state.staffFeedbackAggregations = staffFeedbackAggregations;
		},
		SET_STAFF_FEEDBACK_BYDATE: (state, staffFeedbacks) => {
			state.staffFeedbacksGroupedByDate = staffFeedbacks;
		},
		CLEAR_STAFF_FEEDBACKS: (state) => {
			state.staffFeedbacks = [];
		},
		CLEAR_STAFF_FEEDBACK_AGGREGATIONS: (state) => {
			state.staffFeedbackAggregations = {};
		},
		SET_FEEDBACKS_FILTER: (state, filter) => {
			state.feedbacksFilter = { ...state.feedbacksFilter, ...filter };
		},
		SET_DEFAULT_FEEDBACKS_FILTER: (state, filter) => {
			state.feedbacksFilter = { ...filter, ...defaultFeedbacksFilter };
		},
		SET_FEEDBACKS_PAGINATION: (state, data) => {
			state.feedbacksPagination = { ...state.feedbacksPagination, ...data };
		},

	},
	actions: {
		clearStaffFeedbacks: ({ commit }) => {
			commit('CLEAR_STAFF_FEEDBACKS');
		},
		setRangeType: ({ commit }, rangeType) => {
			commit('SET_RANGE_TYPE', rangeType);
		},
		updateStaffFeedback: async ({ rootGetters }, feedback) => {
			const url = '/api/v3/staff-feedbacks/';
			const results = await feathersClient.service(url).patch(feedback.id, feedback, { query: { $role: rootGetters.currentUserRole, $patchFromWeb: true } });
			return results;
		},
		getDeptFeedback: async ({ rootGetters }, id) => {
			const url = '/api/v3/department-feedbacks';
			let results = await feathersClient.service(url).find({ query: { jobId: id, $role: rootGetters?.currentUserRole, fields: ['staff', 'manager', 'department', 'job'] } });
			results = results.data.length > 0 ? results.data[0] : {};
			return results;
		},
		setFeedbacksFilter: ({ commit }, filter) => {
			commit('SET_FEEDBACKS_FILTER', filter);
		},
		loadStaffFeedbacks: async ({ commit, rootGetters }, filter) => {
			const url = '/api/v3/staff-feedbacks';
			if (Array.isArray(filter.careLocationId) && filter.careLocationId?.length > 0) {
				filter.careLocationId = filter.careLocationId[0];
			}
			const results = await feathersClient.service(url).find(
				{
					query: {
						$role: rootGetters?.currentUserRole,
						fields: ['staff', 'careLocation', 'job'],
						...filter,
			        },
				},
			);
			commit('SET_STAFF_FEEDBACKS', results.data);
			const totalCount = results.total;
			commit('SET_FEEDBACKS_PAGINATION', { total: totalCount });
			return results;
		},
		loadStaffFeedbackAggregations: async ({ commit, rootGetters }, filter) => {
			const url = '/api/v3/staff-feedback-group-by-questions';
			const results = await feathersClient.service(url).find({
				query: {
					$role: rootGetters?.currentUserRole,
					...filter,
				},
			 });
			commit('SET_STAFF_FEEDBACK_AGGREGATIONS', results);
		},
		setFeedbacksPage: ({ commit, state }, page) => {
			const $skip = (page - 1) * state.feedbacksPagination.$limit;
			commit('SET_FEEDBACKS_PAGINATION', { $skip });
			commit('SET_FEEDBACKS_FILTER', { $skip });
		},
		setDefaultFeedbacksFilter: ({ commit }, filter) => {
			commit('SET_DEFAULT_FEEDBACKS_FILTER', filter);
		},
		loadStaffFeedbacksByDate: async ({ commit, rootGetters }, query) => {
			const url = '/api/v3/staff-feedback-group-by-date';
			const results = await feathersClient.service(url).find({
				query: {
					$role: rootGetters?.currentUserRole,
					...query,
				},
			});
			commit('SET_STAFF_FEEDBACK_BYDATE', results);
		},
		clearStaffFeedbackAggregations: ({ commit }) => {
			commit('CLEAR_STAFF_FEEDBACK_AGGREGATIONS');
		},
		getCarelocations: async ({ rootGetters }, account) => {
			let url,
				results;
			if (account.newUserRoles.some((role) => role.careLocationId == null && role.trustId !== null)) {
			    url = '/api/v3/care-locations';
			    results = await feathersClient.service(url).find({ query: { $role: rootGetters.currentUserRole, $paginate: false } });
			} else {
				url = '/api/v3/user-roles';
				results = await feathersClient.service(url).find({ query: { $role: rootGetters.currentUserRole, $getCareLocationsOfRole: true } });
			}
			return results;
		},
	},
};
